import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Menu, Select } from "@activecollab/components";
import PropTypes from "prop-types";
import { TeamPicker, getValidMembers } from "~/components/TeamPicker/TeamPicker";
import { getCompaniesArray } from "~/store/selectors/selector.companies";
import { getUsersByIds } from "~/store/selectors/selector.users";
import { groupUsersByCompany } from "~/utils/utils";

export const SubscribersPicker = ({ target, selected, onChange, hideClients, onClose, userIds }) => {
  const { t } = useTranslation();
  const companies = useSelector(getCompaniesArray);

  const filteredSelected = getValidMembers(selected, userIds);

  const members = useSelector((state) => getUsersByIds(state, userIds));

  const users = useMemo(() => {
    let result = members
      .toList()
      .toJS()
      .map((user) => ({
        id: user.id,
        name: user.display_name,
        image: user.avatar_url.replace("--SIZE--", "24"),
        class: user.class,
      }));

    if (hideClients) {
      result = result.filter((member) => member.class !== "Client");
    }
    return result;
  }, [hideClients, members]);

  const options = useMemo(() => {
    return groupUsersByCompany(companies, users, t);
  }, [companies, users, t]);

  const userIdsMap = useMemo(() => {
    return users.map((user) => {
      return user.id;
    });
  }, [users]);

  return (
    <Menu
      target={target}
      onClose={onClose}
    >
      <Select
        mode="inline"
        selected={filteredSelected}
        options={options}
        onChange={onChange}
        type="multiple"
        noResultText={t("No Results")}
        endAdornment={
          <TeamPicker
            onChange={onChange}
            selected={filteredSelected}
            ids={userIdsMap}
          />
        }
      />
    </Menu>
  );
};

SubscribersPicker.propTypes = {
  target: PropTypes.node.isRequired,
  userIds: PropTypes.array.isRequired,
  selected: PropTypes.array,
  hideClients: PropTypes.bool,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
};
SubscribersPicker.defaultProps = {
  selected: [],
  hideClients: false,
  userIds: [],
};
